import {
  BRAND_SLUGS_WITH_RESTRICTED_RECOMMENDERS,
  SELLER_IDS_WITH_RESTRICTED_RECOMMENDERS,
} from "@personalisation/consts";

export const showRecommenderForBrandSlug = (brandSlug: string) =>
  BRAND_SLUGS_WITH_RESTRICTED_RECOMMENDERS.includes(brandSlug);

export const showRecommenderForSellerId = (sellerId: string) =>
  SELLER_IDS_WITH_RESTRICTED_RECOMMENDERS.includes(sellerId);
